import { VabsAchAccountType, VabsWireAccountType } from '../api/apollo';
import { capitalize } from '../lib/utils/text';
import { SelectOption } from './components/select';
import { Select } from './components/select/ui/select';

export const OPTIONS_ACH = Object.values(VabsAchAccountType).map((v) => ({
    value: v,
    label: `${capitalize(v)} account`,
}));

export const OPTIONS_WIRE = Object.values(VabsWireAccountType).map((v) => ({
    value: v,
    label: `${capitalize(v)} account`,
}));

export const VabsAchAccountTypeSelect: React.FC<{
    value: VabsAchAccountType;
    onSelect: (v: VabsAchAccountType) => void;
    errorText?: string;
}> = ({ value, onSelect, errorText }) => {
    const option = OPTIONS_ACH.find((i) => i.value === value);
    const handleSelect = (option) => {
        onSelect(option.value);
    };
    return (
        <Select
            placeholder="Account type"
            options={OPTIONS_ACH}
            value={option as SelectOption}
            onSelect={handleSelect}
            isInvalid={!!errorText}
        />
    );
};

export const VabsWireAccountTypeSelect: React.FC<{
    value: VabsWireAccountType;
    onSelect: (v: VabsWireAccountType) => void;
    errorText?: string;
}> = ({ value, onSelect, errorText }) => {
    const option = OPTIONS_WIRE.find((i) => i.value === value);
    const handleSelect = (option) => {
        onSelect(option.value);
    };
    return (
        <Select
            placeholder="Account type"
            options={OPTIONS_WIRE}
            value={option as SelectOption}
            onSelect={handleSelect}
            isInvalid={!!errorText}
        />
    );
};
